var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCd2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 10,
    viewBox: "0 0 46 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2015_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9819 0H35.9819V10H37.9819V6H40.5942L44.5866 9.99244H46.0008V8.57823L42.4253 5.00272L46.0008 1.42724L46.0008 0.0130224L44.5866 0.0130835L40.5996 4H37.9819V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C13.7909 0 12 1.79086 12 4V10H22V0H16ZM16 2C14.8954 2 14 2.89543 14 4V8H20V2H16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0H24V2H32V4H26H24V6V8V10H26H34V8H26V6H32H34V4V2V0H32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H0V10H2V6H4.61225L8.60469 9.99244H10.0189V8.57823L6.44339 5.00271L10.0189 1.42724V0.0130226L8.60471 0.0130837L4.61769 4H2V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2015_2879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd2C);
export default __webpack_public_path__ + "static/media/cd2c.fa45906f298022bfe7bd10a6a7410f05.svg";
export { ForwardRef as ReactComponent };